import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import { getGwActivateBookListDB } from "@/interface";
import { aes128Decrypt } from "@/utils/aes128.js";
import { handleBookList } from "@/utils";

export default new Vuex.Store({
  state: {
    bookList: [],
    curBook: {},
  },
  getters: {
    bookList: (state) => state.bookList,
    curBook: (state) => state.curBook,
  },
  actions: {
    logOut() {
      localStorage.removeItem("rypc_userInfo");
      localStorage.removeItem("rypc_token");
      // this.$router.push("/login");
      location.replace(`/lry/login`);
      // location.replace(`https://ebook.pep.com.cn/lry/login`);
    },
    getActivateBookListAction({ commit }, params) {
      return new Promise((resolve) => {
        getGwActivateBookListDB(params)
          .then((res) => {
            const data = aes128Decrypt(res.data);
            const newList = handleBookList(data);
            commit("SET_BOOK_LIST", newList);
            resolve(res);
          })
          .catch((error) => {
            resolve(error);
          });
      });
    },
    choiceCurBook({ commit }, params) {
      commit("SET_CUR_BOOK", params);
    },
  },
  mutations: {
    SET_BOOK_LIST: (state, vl) => {
      state.bookList = vl;
    },
    SET_CUR_BOOK: (state, vl) => {
      state.curBook = vl;
    },
  },
  modules: {},
});
